import { render, staticRenderFns } from "./DealerProducts.vue?vue&type=template&id=cec4a6d8&scoped=true&"
import script from "./DealerProducts.vue?vue&type=script&lang=js&"
export * from "./DealerProducts.vue?vue&type=script&lang=js&"
import style0 from "./DealerProducts.vue?vue&type=style&index=0&id=cec4a6d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec4a6d8",
  null
  
)

export default component.exports